var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.media
    ? _c("div", { staticClass: "test-editor" }, [
        _c("h3", [_vm._v("Test questions")]),
        _vm._v(" "),
        _c("ul", { staticClass: "type-chooser" }, [
          _c(
            "li",
            {
              class: { active: _vm.item.testqs.type == "independent" },
              on: {
                click: function($event) {
                  _vm.item.testqs.type = "independent"
                }
              }
            },
            [_vm._v("Independent")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.item.testqs.type == "interactive" },
              on: {
                click: function($event) {
                  _vm.item.testqs.type = "interactive"
                }
              }
            },
            [_vm._v("Interactive")]
          )
        ]),
        _vm._v(" "),
        _vm.item.testqs.type == "independent"
          ? _c("div", [
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Access password")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.item.password,
                      expression: "item.password"
                    }
                  ],
                  domProps: { value: _vm.item.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.item, "password", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.generatePassword($event)
                      }
                    }
                  },
                  [_vm._v("Generate")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Required correct")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.item.testqs.independent.passingScore,
                      expression: "item.testqs.independent.passingScore"
                    }
                  ],
                  domProps: { value: _vm.item.testqs.independent.passingScore },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.item.testqs.independent,
                        "passingScore",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "questions" },
                [
                  _vm._l(_vm.item.testqs.independent.questions, function(
                    question,
                    qi
                  ) {
                    return _c("li", [
                      _c("div", { staticClass: "field" }, [
                        _c("label", [
                          _vm._v("Question #" + _vm._s(qi + 1) + ":")
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: question.text,
                              expression: "question.text"
                            }
                          ],
                          domProps: { value: question.text },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(question, "text", $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", [_vm._v("Answers:")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "answers" },
                          [
                            _vm._l(question.answers, function(answer, ai) {
                              return _c("li", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: answer.valid,
                                      expression: "answer.valid"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(answer.valid)
                                      ? _vm._i(answer.valid, null) > -1
                                      : answer.valid
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = answer.valid,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              answer,
                                              "valid",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              answer,
                                              "valid",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(answer, "valid", $$c)
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: answer.text,
                                      expression: "answer.text"
                                    }
                                  ],
                                  domProps: { value: answer.text },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        answer,
                                        "text",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "remove",
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return question.answers.splice(ai, 1)
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                )
                              ])
                            }),
                            _vm._v(" "),
                            _c("li", { staticClass: "new" }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return question.answers.push({
                                        valid: false,
                                        text: ""
                                      })
                                    }
                                  }
                                },
                                [_vm._v("+")]
                              )
                            ])
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "remove",
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.item.testqs.independent.questions.splice(
                                qi,
                                1
                              )
                            }
                          }
                        },
                        [_vm._v("×")]
                      )
                    ])
                  }),
                  _vm._v(" "),
                  _c("li", { staticClass: "new" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.item.testqs.independent.questions.push({
                              text: "",
                              answers: []
                            })
                          }
                        }
                      },
                      [_vm._v("+")]
                    )
                  ])
                ],
                2
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.item.testqs.type == "interactive"
          ? _c("div", [
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Access password")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.item.password,
                      expression: "item.password"
                    }
                  ],
                  domProps: { value: _vm.item.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.item, "password", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.generatePassword($event)
                      }
                    }
                  },
                  [_vm._v("Generate")]
                )
              ]),
              _vm._v(" "),
              _vm.item.chapters
                ? _c(
                    "ul",
                    { staticClass: "chapters" },
                    _vm._l(_vm.item.chapters, function(chapter, ci) {
                      return _c(
                        "li",
                        [
                          _vm._l([_vm.item.testqs.interactive[ci]], function(
                            intv
                          ) {
                            return [
                              _c("span", { staticClass: "time-range" }, [
                                _c("span", { staticClass: "start-time" }, [
                                  _vm._v(_vm._s(_vm.formatTime(chapter.time)))
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "end-time" }, [
                                  _vm._v(
                                    _vm._s(_vm.formatTime(_vm.endTime(ci)))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "chapter-title" }, [
                                  _vm._v(_vm._s(chapter.title))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "field" }, [
                                _c("label", [_vm._v("Required correct")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: intv.passingScore,
                                      expression: "intv.passingScore"
                                    }
                                  ],
                                  domProps: { value: intv.passingScore },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        intv,
                                        "passingScore",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "questions" },
                                [
                                  _vm._l(intv.questions, function(
                                    question,
                                    qi
                                  ) {
                                    return _c("li", [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("Question:")]),
                                        _vm._v(" "),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: question.text,
                                              expression: "question.text"
                                            }
                                          ],
                                          domProps: { value: question.text },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                question,
                                                "text",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("Answers:")]),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          { staticClass: "answers" },
                                          [
                                            _vm._l(question.answers, function(
                                              answer,
                                              ai
                                            ) {
                                              return _c("li", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: answer.valid,
                                                      expression: "answer.valid"
                                                    }
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      answer.valid
                                                    )
                                                      ? _vm._i(
                                                          answer.valid,
                                                          null
                                                        ) > -1
                                                      : answer.valid
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a = answer.valid,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              answer,
                                                              "valid",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              answer,
                                                              "valid",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          answer,
                                                          "valid",
                                                          $$c
                                                        )
                                                      }
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: answer.text,
                                                      expression: "answer.text"
                                                    }
                                                  ],
                                                  domProps: {
                                                    value: answer.text
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        answer,
                                                        "text",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "remove",
                                                    attrs: { href: "" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return question.answers.splice(
                                                          ai,
                                                          1
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("×")]
                                                )
                                              ])
                                            }),
                                            _vm._v(" "),
                                            _c("li", { staticClass: "new" }, [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return question.answers.push(
                                                        {
                                                          valid: false,
                                                          text: ""
                                                        }
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("+")]
                                              )
                                            ])
                                          ],
                                          2
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "remove",
                                          attrs: { href: "" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return intv.questions.splice(
                                                qi,
                                                1
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("×")]
                                      )
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _c("li", { staticClass: "new" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return intv.questions.push({
                                              text: "",
                                              answers: []
                                            })
                                          }
                                        }
                                      },
                                      [_vm._v("+")]
                                    )
                                  ])
                                ],
                                2
                              )
                            ]
                          })
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e()
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }